export default "__VITE_PUBLIC_ASSET__60706719__"